export default __webpack_public_path__ + "static/media/hht1_storybook_02.3556b454.png";